;(function () {
	const stopVideo = (section) => {
		section.querySelectorAll('video').forEach((video) => {
			video.pause()
		})
	}

	const playVideo = (section) => {
		section.querySelectorAll('.authentication__media--video.autoplay video').forEach((video) => {
			video.autoplay = true

			if (video.paused) {
				video.play()
			}
		})
	}

	const initPlayButton = (media) => {
		const video = media.querySelector('video')
		const button = media.querySelector('.js-play-video-authentication')

		if (!video || !button) return

		video.addEventListener('play', () => button.classList.add('active'))
		video.addEventListener('pause', () => button.classList.remove('active'))

		// The click target is the whole media box, not just the button: once playing,
		// the button fades out and only reappears on hover (see the CSS), so on touch
		// devices — which have no hover — a tap anywhere on the video still reaches this
		// listener and can pause it again, even while the button itself is invisible.
		media.onclick = () => {
			if (video.paused) {
				video.play()
			} else {
				video.pause()
			}
		}
	}

	const initSection = () => {
		const sections = document.querySelectorAll('.authentication-section')

		const sectionObserver = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) playVideo(entry.target)
				else stopVideo(entry.target)
			})
		})

		const sectionResizeObserver = new ResizeObserver((entries) => {
			const [entry] = entries
			playVideo(entry.target)
		})

		sections.forEach((section) => {
			sectionObserver.observe(section)
			sectionResizeObserver.observe(section)

			section.querySelectorAll('.authentication__media--video').forEach(initPlayButton)
		})
	}

	initSection()

	document.addEventListener('shopify:section:load', function () {
		initSection()
	})
})()
